import { Component, type ErrorInfo, type ReactNode } from 'react'

interface Props { children: ReactNode }
interface State { error?: Error }

export class ErrorBoundary extends Component<Props, State> {
  state: State = {}

  static getDerivedStateFromError(error: Error): State { return { error } }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('UI error', error, info.componentStack)
  }

  render() {
    if (this.state.error) {
      return (
        <main className="fatal-error">
          <p className="eyebrow">Ошибка интерфейса</p>
          <h1>Не удалось показать приложение</h1>
          <p>{this.state.error.message}</p>
          <button className="button primary" onClick={() => window.location.reload()}>Перезагрузить</button>
        </main>
      )
    }
    return this.props.children
  }
}

